import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledCompetitorsItem = styled.div`
    padding: 8px 4px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    border-top: 1px solid ${colorsPalettes.carbon[100]};
    &:first-child {
        padding-top: 0;
        border: none;
    }
    &:last-child {
        padding-bottom: 0;
    }
`;

export const StyledRemoveIconButton = styled(IconButton)<{ disabled: boolean }>`
    &:hover {
        & ${SWReactIcons} {
            svg > path {
                fill: ${({ disabled }) => (disabled ? colorsPalettes.midnight[100] : colorsPalettes.carbon[300])};
            }
        }
    }
    & ${SWReactIcons} {
        svg > path {
            fill: ${({ disabled }) => (disabled ? colorsPalettes.midnight[100] : colorsPalettes.carbon[300])};
        }
    }
    ${({ disabled }) => disabled && `pointer-events: none;`};
`;

export const StyledRemoveIconContainer = styled.div`
    margin-left: auto;
`;
